/**
 * Open Google Maps with directions to a business, in a new tab.
 */
export const directionsUrl = (target = {}) => {
  const coords = (target.location && target.location.coordinates) || [];
  const [lng, lat] = coords;
  if (lat && lng) return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  const address = [
    target.address && target.address.line1,
    target.address && target.address.city,
    target.address && target.address.pincode,
  ].filter(Boolean).join(', ');
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address || target.businessName || '')}`;
};

export const openDirections = (target) => window.open(directionsUrl(target), '_blank', 'noopener');

export default openDirections;
